import { Checkbox, Icon } from "@mui/material";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { AlertInfo, CustomButton, DefaultLoader } from "../../components";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import {
  clearErrorInvestCheckout,
  clearInvestCheckoutLoading,
  investCheckout,
} from "../fundSelectionStep3/redux/actions";
import { getCustomer } from "../redux/action";
import "./style.summary.scss";
import { showError } from "../../globalRedux/actions";
import AccountVerificationPopup from "../../components/AccountVerificationPopup";

const riskDisclosure =
  "https://www.principal.com.my/en/ut-loan-financing-risk-my/mv";
const principalTnCPDF =
  "https://www.principal.com.my/sites/default/files/pdf-uploads/Principal%20Mini%20Program%20%28IMMF%20Class%20D%29%20Terms%20and%20Conditions.pdf";

function PlanSummary({
  fundsCode = [],
  investCheckout,
  investCheckoutLoading,
  history,
  investCheckoutError,
  showAccountVerificationError,
  clearErrorInvestCheckout,
  profile,
  getCustomer,
  loading,
  clearInvestCheckoutLoading,
  lastInvestAmount,
  location,
}) {
  const [isCheck, setCheck] = useState(false);
  const [persistedSelectedFunds] = useState(() =>
    localStorage.getItem("currentPlan")
  );

  const totalFundsAmount = lastInvestAmount;

  useEffect(() => {
    if (!persistedSelectedFunds) {
      history.back();
    }
  }, [persistedSelectedFunds]);

  useEffect(() => {
    clearInvestCheckoutLoading();
    getCustomer();
  }, []);

  const handleSubmit = () => {
    dataLayerGTM(
      "click_tag",
      "Click",
      "Button",
      "Plan Cash In Summary - Continue"
    );

    const parsedPersistedPlan = JSON.parse(persistedSelectedFunds);

    investCheckout({
      cifPlanId: location?.state?.cifPlanId,
      amount: totalFundsAmount,
      ccy: "MYR",
      // pass fundCd, amount, and amountCcy from funds payload
      funds: fundsCode.map(({ fundCd, amount, amountCcy }) => ({
        fundCd,
        amount,
        amountCcy,
      })),
      customerChannelCode: "Mini Program",
      cifId: profile.masterId,
      name: profile.fullName,
      email: profile && profile.email,
      source: "GO+ Deeplink",
      sourceType: `Bundle ${
        parsedPersistedPlan?.plan === "supercharge"
          ? "SuperCharge"
          : "PowerSaver"
      }`,
    });
  };

  const handleNavigate = url => {
    window.my.navigateTo({
      url: "/pages/link/link?url=" + encodeURIComponent(url),
    });
  };

  const principalTnC = () => {
    window.my.showLoading();
    window.my.postMessage({
      api: "downloadFile",
      pdf: principalTnCPDF,
      event: "openPdf",
    });
  };

  if (investCheckoutLoading || loading) return <DefaultLoader />;

  return (
    <>
      <AlertInfo
        description="We are facing some technical issues, and we are working very hard to resolve the issue."
        isOpen={investCheckoutError && !showAccountVerificationError}
        isTimeout
        handleAction={() => {
          clearErrorInvestCheckout();
        }}
      />
      <AccountVerificationPopup
        isOpen={investCheckoutError && showAccountVerificationError}
        onChat={clearErrorInvestCheckout}
        onClose={clearErrorInvestCheckout}
        title="Information Verification"
      />
      <div className="l-plan-summary deposit-wrapper">
        <div className="back-btn-wrapper">
          <Icon
            className="material-icons-outlined"
            onClick={() => {
              dataLayerGTM(
                "click_tag",
                "Click",
                "Button",
                "Fund Cash In Summary - back button"
              );
              history.back();
            }}
          >
            arrow_back
          </Icon>
          <h4 className="l-plan-summary__title">Your Investment Summary</h4>
        </div>
      </div>

      <div>
        {fundsCode.map((item, index) => (
          <div className="l-plan-summary__content" key={index}>
            <h2>{item.name}</h2>
            <p style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Cash In</span>
              <span style={{ fontWeight: "700" }}>
                RM{" "}
                <NumberFormat
                  value={item.amount}
                  thousandSeparator
                  displayType="text"
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </span>
            </p>
            <p
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
                marginTop: "5px",
                marginBottom: "5px",
              }}
            >
              <span>
                Inclusive of Sales Charge
                <br />
                <span style={{ fontSize: "12px", fontWeight: 400 }}>
                  ({item.serviceTaxPerc || 0}% SST applicable on Sales Charge)
                </span>
              </span>
              <span style={{ fontWeight: "700" }}>
                {!item.salesCharge
                  ? 0
                  : item.salesCharge ||
                    process.env.REACT_APP_RETIREMENT_SALES_CHARGE.trim()}
                %
              </span>
            </p>
            <span
              style={{
                color: "#0061A0",
                fontSize: "14px",
                lineHeight: "22px",
                fontWeight: "700",
              }}
              onClick={() => {
                handleNavigate(item.fundInfoUrl);
              }}
            >
              View fund info
            </span>
          </div>
        ))}
      </div>

      <div className="l-plan-summary-recipe">
        <p className="l-plan-summary-recipe__label">Total Cash In</p>
        <p className="l-plan-summary-recipe__amount">
          RM{" "}
          <NumberFormat
            value={totalFundsAmount}
            thousandSeparator
            displayType="text"
            decimalScale={2}
            fixedDecimalScale={true}
          />
        </p>
      </div>
      <div className="l-plan-summary__terms">
        <Checkbox
          checked={isCheck}
          onChange={() => setCheck(!isCheck)}
          color="primary"
          style={{ margin: 0, padding: 0 }}
        />
        <div className="l-plan-summary__terms-text">
          <p style={{ marginBottom: "8px" }}>
            I have read and agreed to{" "}
            <span onClick={principalTnC}>Principal’s Terms & Conditions</span>,
            the Unit Trust Loan Financing{" "}
            <span onClick={() => handleNavigate(riskDisclosure)}>
              Risk Disclosure Statement
            </span>
            , and have read and understood the relevant Prospectus, Information
            Memorandum and/or Disclosure Document including any supplemental
            thereof and the Product Highlight Sheet (if any) before Investing.
          </p>
          <p>
            I acknowledge the investment risk, and aware that the fund is not
            E-money, deposit, or capital guaranteed/protected by PIDM. Losses
            are not covered by the Capital Market Compensation Fund.
          </p>
        </div>
      </div>

      <div className="l-plan-summary__confirm">
        <CustomButton
          text="Cash In"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={!isCheck || investCheckoutLoading}
          onClick={handleSubmit}
        />
      </div>
    </>
  );
}

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    profile: state.goal.profile,
    fundsCode: state.fundSelectionReducer.fundsCode,
    investCheckoutLoading: state.investCheckoutReducer.investCheckoutLoading,
    investCheckoutError: state.investCheckoutReducer.investCheckoutError,
    showAccountVerificationError:
      state.investCheckoutReducer.showAccountVerificationError,
    lastInvestAmount: state.investPortfolioReducer.lastInvestAmount,
  }),
  {
    investCheckout,
    clearErrorInvestCheckout,
    getCustomer,
    clearInvestCheckoutLoading,
    showError,
  }
);

export default compose(
  withRouter,
  withConnect
)(PlanSummary);
